import { buildGenerationTargetCacheKey } from '@/lib/generation/generation-reference';
import type { GenerationReferenceDraft, GenerationTargetKey } from '@/types/generation-reference';

/**
 * draftRef / syncChain 写回前：仅当 draft.target 与当前提交 target 一致才 adopt。
 * 防止 target 切换竞态把上一节点草稿带进当前同步链。
 */
export function shouldAdoptDraftForTarget(
  draft: GenerationReferenceDraft,
  target: GenerationTargetKey
): boolean {
  return buildGenerationTargetCacheKey(draft.target) === buildGenerationTargetCacheKey(target);
}
